import React from 'react';
import { Brain } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-r from-ariyva-indigo to-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-3 mb-6 md:mb-0">
            <Brain className="w-8 h-8 text-ariyva-cyan" />
            <div>
              <h2 className="text-xl font-bold">ARIYVA</h2>
              <p className="text-sm text-gray-300">Human + AI Data Intelligence</p>
            </div>
          </div>

          <div className="text-center md:text-right">
            <p className="text-gray-300">
              © {new Date().getFullYear()} Ariyva. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;